import queryKeys from '@/constants/query-keys';
import { getAuthToken, useAuthToken } from '@/store/auth';
import { useSiteStore } from '@/store/site';
import { cloudUrlParser } from '@/utils/aws-domain-util';
import { fetchComposer } from '@nf/utils-common/compose-fetch';
import { BankDetailInfo } from './types';
import { useQuery } from '@tanstack/react-query';


const fetchBankDetail = async (): Promise<BankDetailInfo> => {
	const authToken = getAuthToken();
	const { apiDomain } = useSiteStore.getState();
	const response = await fetchComposer.postWithBearer(cloudUrlParser(`${apiDomain.ctcdDomain}/DepWit/GetBankDetail`))(authToken);
	
	if (!response.ok) {
		throw new Error(`${response.status}: ${response.statusText}`, { cause: response });
	}

	return await response.json();
};

export const useBankDetail = () => {
	const authToken = useAuthToken();
	const { data, isLoading, isError, error, refetch, isFetching } = useQuery({
		queryKey: [queryKeys.BANK_DETAIL],
		queryFn: () => fetchBankDetail(),
		staleTime: 1000 * 60,
		cacheTime: 1000 * 60,
		refetchOnWindowFocus: false,
		enabled: authToken !== undefined,
	});

	if (isError) {
		console.error(error);
	}
    
	return {
		refetch,
		bankDetail: data,
		isLoading,
		isError,
		error,
		isFetching
	};
};